import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from '@zendeskgarden/react-theming'
import App from './components/status_page/App'

import '@zendeskgarden/css-bedrock/dist/index.css'
import '@zendeskgarden/react-buttons/dist/styles.css'
import '@zendeskgarden/react-dropdowns/dist/styles.css'
import '@zendeskgarden/react-forms/dist/styles.css'
import '@zendeskgarden/react-grid/dist/styles.css'
import '@zendeskgarden/react-modals/dist/styles.css'
import '@zendeskgarden/react-notifications/dist/styles.css'
import '@zendeskgarden/react-tags/dist/styles.css'
import '@zendeskgarden/react-tooltips/dist/styles.css'

const theme = {}

document.addEventListener('DOMContentLoaded', () => {
  const flashNoticeElem = document.getElementById('flash_notice_message')
  const flashNotice = flashNoticeElem && flashNoticeElem.dataset.message

  const flashErrorElem = document.getElementById('flash_error_message')
  const flashError = flashErrorElem && flashErrorElem.dataset.message

  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <App flashNotice={flashNotice} flashError={flashError} />
    </ThemeProvider>,
    document.getElementById('root')
  )
})
